import React, { FC, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Avatar, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import VerifiedIcon from '@mui/icons-material/Verified';
import GppBadIcon from '@mui/icons-material/GppBad';
import { User } from '../../lib/interfaces/User';
import SimpleModal from '../Modals/SimpleModal';
import { useAppDispatch } from '../../hooks/redux';
import {
	setActivationResultModalOpen,
	setLoginModalOpen,
} from '../../redux/reducers/ui/modalsReducer';
import Loader from '../Simple/Loader/Loader';
import ResendActivationButton from './ResendActivationButton';
import useUserMeQuery from '../../reactQuery/hooks/useUserMeQuery';
import PATHS from '../../lib/consts/paths';

const ActivationResultModal: FC<any> = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const { data: currentUser } = useUserMeQuery();
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	const data: any = queryClient.getQueryState<User, Error>(['activate-user']);
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const handleClose = () => {
		dispatch(setActivationResultModalOpen(false));
		if (!currentUser && !data.error) {
			dispatch(setLoginModalOpen(true));
			navigate(PATHS.homePage);
		}
	};

	const avatarClass = classNames('AuthModal__avatar', {
		success: data.data,
		error: data.error,
	});

	const content: React.ReactElement = (
		<Container component="main" maxWidth="xs">
			<div className="AuthModal__wrapper">
				<div className="AuthModal__title">
					<Avatar className={avatarClass}>
						{data.data && <VerifiedIcon />}
						{data.error && <GppBadIcon />}
					</Avatar>
					<Typography
						component="h1"
						variant="h6"
						style={{ textAlign: 'center', marginTop: '10px' }}
					>
						{data.data && t('activationSuccessTitle')}
						{data.error && t('activationErrorTitle')}
					</Typography>
					<Typography
						component="p"
						variant="body1"
						sx={{ textAlign: 'center', marginTop: '10px' }}
					>
						{data.data && t('activationSuccessBody')}
						{data.error && t('activationErrorBody')}
					</Typography>
					{data.error && currentUser && (
						<div>
							<Typography
								component="p"
								variant="body1"
								sx={{ textAlign: 'center', marginTop: '10px' }}
							>
								{t('activationErrorResend')}
								<ResendActivationButton />
							</Typography>
						</div>
					)}
				</div>
			</div>
		</Container>
	);

	useEffect(() => {
		if (data.error || data.data) {
			setIsOpen(true);
		}
	}, [data.error, data.data, data.isFetching]);

	return (
		<div>
			<SimpleModal
				isOpen={isOpen}
				handleClose={handleClose}
				content={content}
				hideActions
			/>
			{data.isFetching && <Loader />}
		</div>
	);
};

export default ActivationResultModal;
